import React,{Component} from 'react';
import {Navbar, NavbarBrand, Nav, NavItem,Button, NavbarToggler, Collapse} from 'reactstrap';
import {NavLink} from 'react-router-dom';
import '../css/styles.css';
class Header extends Component{
    constructor(props){
        super(props);
        this.state = {
            isNavOpen :false,
            ismodalOpen:false
        };
        this.toggleNav = this.toggleNav.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
       
    }
    toggleNav(){
       this.setState({
           isNavOpen: !this.state.isNavOpen
       });
   }
   toggleModal(){
       this.setState({
           ismodalOpen: !this.state.ismodalOpen
       });
   }
    render(){
        return(
            <Navbar dark expand="md" className="btm-ml navbar ">
                    <div className="container fixed-top navbar-dark" >
                    <NavbarBrand className="mr-auto ml-3 d-md-block" href="/"><svg width="56" height="34" viewBox="0 0 56 53" fill="none" xmlns="http://www.w3.org/2000/svg">
<ellipse cx="28" cy="26.5" rx="28" ry="26.5" fill="#511E1E"/>
<path d="M41.855 11.552H43.967C46.6977 11.552 48.7243 11.232 50.047 10.592C48.1697 13.3653 46.3563 15.776 44.607 17.824H43.583C41.407 17.824 39.295 17.4827 37.247 16.8C34.3457 19.1893 32.0203 22.368 30.271 26.336C34.7937 27.488 39.8283 28.1707 45.375 28.384C46.655 31.6267 47.5297 36.832 47.999 44H31.423C30.6977 40.8427 29.5883 37.9413 28.095 35.296C26.6443 32.608 25.1297 30.7733 23.551 29.792C23.2523 33.2907 23.103 36.1067 23.103 38.24C23.103 40.3733 23.167 42.2933 23.295 44H9.215C8.40433 37.728 7.999 32.4373 7.999 28.128C7.999 23.776 8.319 18.4 8.959 12H26.751C25.471 17.2907 24.5963 21.728 24.127 25.312C26.047 22.1547 28.0523 19.5093 30.143 17.376C32.2763 15.2 34.7937 13.3653 37.695 11.872C38.8043 11.6587 40.191 11.552 41.855 11.552Z" fill="#06A1F9"/>
</svg>

</NavbarBrand>
                        <NavbarToggler onClick={this.toggleNav} className="ham ml-auto mt-2 mr-2"/>
                       

                        <Collapse isOpen={this.state.isNavOpen} navbar>
                            <Nav navbar className="ml-auto">
                            <NavItem>
                                <a className="nav-link" onClick={this.toggleNav} href="/" >Home</a>
                            </NavItem>
                            <NavItem>
                                <a className="nav-link" href="/#about" onClick={this.toggleNav}>About Me</a>
                            </NavItem>
                            <NavItem>
                                <a className="nav-link" href="/#project" onClick={this.toggleNav}>My Project</a>    
                            </NavItem>
                            <NavItem>
                                <NavLink className="nav-link" to='/con' onClick={this.toggleNav}> Contact Us</NavLink>
                            </NavItem>
                            </Nav>
                            
                        </Collapse>
                    </div>
                </Navbar>
        )
    }
}
export default Header;